import ModalIconWithStatus from '@/components/App/ModalIconWithStatus';
import LoadingIcon from '@/components/LoadingIcon';
import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

type Props = {
  children?: any;
};

interface ModalProps {
  title?: string | React.ReactElement | React.ReactNode;
  content?: string | React.ReactElement | React.ReactNode;
  onClose?: () => void;
  modalType?: 'success' | 'error' | 'info' | 'confirm' | 'loading';
  onConfirm?: () => void;
  okText?: string;
  cancelText?: string;
  loadingText?: string;
}
let ref: any = React.createRef<any>();

export const ModalUtils = {
  show: (config: ModalProps) => {
    ref.current?.displayModal(config);
  },

  error: (config: Omit<ModalProps, 'modalType' | 'onConfirm'>) => {
    ref.current?.displayModal({
      ...config,
      modalType: 'error',
    });
  },

  success: (config: Omit<ModalProps, 'modalType' | 'onConfirm'>) => {
    ref.current?.displayModal({
      ...config,
      modalType: 'success',
    });
  },

  info: (config: Omit<ModalProps, 'modalType' | 'onConfirm'>) => {
    ref.current?.displayModal({
      ...config,
      modalType: 'info',
    });
  },
  confirm: (config: Omit<ModalProps, 'modalType'>) => {
    ref.current?.displayModal({
      ...config,
      modalType: 'confirm',
    });
  },
  loading: (config: Omit<ModalProps, 'modalType'>) => {
    ref.current?.displayModal({
      ...config,
      modalType: 'loading',
    });
    return () => {
      ref.current?.close();
    };
  },
};
export default function ModalWrapper({ children }: Props) {
  const [modalConfig, setModalConfig] = React.useState<ModalProps>();

  const onCloseModal = React.useCallback(() => {
    if (modalConfig?.onClose) {
      modalConfig?.onClose();
    }
    setModalConfig(undefined);
  }, [modalConfig]);

  const onConfirmModal = React.useCallback(() => {
    if (modalConfig?.onConfirm) {
      modalConfig?.onConfirm();
    }
    setModalConfig(undefined);
  }, [modalConfig]);

  React.useEffect(() => {
    ref.current = {
      displayModal: (config: ModalProps) => {
        setModalConfig(config);
      },
      close: () => {
        setModalConfig(undefined);
      },
    };
  }, []);

  return (
    <>
      {children}
      <Modal className={`${modalConfig?.modalType || 'info'} static-modal`} isOpen={!!modalConfig} unmountOnClose={true}>
        {modalConfig?.modalType === 'loading' ? (
          <div className="text-center py-50">
            <LoadingIcon />
            <div className="mt-10 text-20 fw-500">{modalConfig?.loadingText || 'Loading'}</div>
          </div>
        ) : (
          <>
            <ModalBody>
              <div className="row x-gap-10 d-flex items-center">
                <div className="col-auto">
                  <ModalIconWithStatus status={modalConfig?.modalType || 'info'} />
                </div>
                <div className="col fw-500 text-18 ">{modalConfig?.title}</div>
              </div>

              <div className="content mt-10"> {modalConfig?.content}</div>
            </ModalBody>
            {modalConfig?.modalType === 'confirm' ? (
              <ModalFooter className="d-flex justify-content-between">
                <button className="button px-15 bg-light-2 py-10" onClick={onCloseModal}>
                  <i className="icon-close text-12 px-5" />
                  {modalConfig?.cancelText || 'Cancel'}
                </button>
                <button className="button px-15 bg-blue-1  py-10 text-white" onClick={onConfirmModal}>
                  <i className="icon-check text-12 px-5" />
                  {modalConfig?.okText || 'Confirm'}
                </button>
              </ModalFooter>
            ) : (
              <ModalFooter>
                <button className="button px-15 bg-light-2  py-10 text-black" onClick={onCloseModal}>
                  <i className="icon-close text-12 px-5" />
                  {modalConfig?.okText || 'Close'}
                </button>
              </ModalFooter>
            )}
          </>
        )}
      </Modal>
    </>
  );
}
